import React from 'react';

export interface ListProps {
  /**
   * List type - unordered (ul) or ordered (ol)
   */
  variant?: 'unordered' | 'ordered';
  /**
   * List style type
   */
  listStyle?:
    | 'none'
    | 'disc'
    | 'circle'
    | 'square'
    | 'decimal'
    | 'lower-alpha'
    | 'upper-alpha'
    | 'lower-roman'
    | 'upper-roman';
  /**
   * List items
   */
  children: React.ReactNode;
  /**
   * Custom CSS classes
   */
  className?: string;
  /**
   * Inline styles
   */
  style?: React.CSSProperties;
  /**
   * HTML id attribute
   */
  id?: string;
  /**
   * ARIA label
   */
  'aria-label'?: string;
  /**
   * ARIA described by
   */
  'aria-describedby'?: string;
  /**
   * ARIA role override
   */
  role?: string;
}

export const List: React.FC<ListProps> = ({
  variant = 'unordered',
  listStyle = 'none',
  children,
  className = '',
  style,
  id,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedby,
  role,
}) => {
  const baseClass = 'hi-ui-list';
  const variantClass = `hi-ui-list-${variant}`;
  const listStyleClass = listStyle !== 'none' ? `hi-ui-list-style-${listStyle}` : '';

  const allClasses = `${baseClass} ${variantClass} ${listStyleClass} ${className}`.trim();

  const Element = variant === 'ordered' ? 'ol' : 'ul';

  return (
    <Element
      className={allClasses}
      style={style}
      id={id}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
      role={role}
    >
      {children}
    </Element>
  );
};
